import React, { useLayoutEffect, useState } from 'react';
import ViewSwitcher from 'ps-components/ViewSwitcher/ViewSwitcher';
import { ManageUsers, ReportInspector, InternalTools } from './TabContainers';
import { useHistory, useLocation } from 'react-router-dom';
import { useQueryParams } from '../../hooks/util';
import './MarketPayInternal.scss';

const MarketPayInternal = () => {
  const [tabIndex, setTabIndex] = useState(0)
  const TAB_LIST = ['MANAGE SUPER ADMINS', 'REPORT INSPECTOR', 'INTERNAL TOOLS']
  const TAB_QUERY_PARAMS = ['manageusers', 'reportinspector', 'internaltools']

  const history = useHistory();
  const location = useLocation();
  const query = useQueryParams()
  const tab = query.get('tab')

  const handleTabSwitch = (tabIndex: number) => {
    const params = new URLSearchParams(location.search);
    params.set('tab', TAB_QUERY_PARAMS[tabIndex]);
    history.push({ search: params.toString() });
  }

  useLayoutEffect(() => {
    if (tab?.toLocaleLowerCase() === TAB_QUERY_PARAMS[0]) setTabIndex(0)
    if (tab?.toLocaleLowerCase() === TAB_QUERY_PARAMS[1]) setTabIndex(1)
    if (tab?.toLocaleLowerCase() === TAB_QUERY_PARAMS[2]) setTabIndex(2)
  }, [tab])

  return (
    <div className="superadmin">
       <div className="superadmin__navlinks">
          <ViewSwitcher
            isSticky={true}
            tabList={TAB_LIST}
            activeTab={tabIndex}
            tabSwitch={handleTabSwitch}
          />
      </div>

      <div className="view__container">
        { tabIndex === 0 && <ManageUsers /> }
        { tabIndex === 1 && <ReportInspector /> }
        { tabIndex === 2 && <InternalTools /> }
      </div>
    </div>
  );
}

export default MarketPayInternal;
